module.exports = __webpack_public_path__ + "static/bigmao-138ea0d6127cc7c5ddab54d48d157fd4.jpg";